import React from "react";
import PropTypes from "prop-types";

import HoverTextOverlay from "core/HoverTextOverlay";
import PhotoIcon from "core/ReusableIcons/Photo";

import { SubmissionPhoto } from "./styles";

const SubmissionsGridItemContent = ({ data = {} }) => {
    return (
        <>
            {data.autoDenied ? (
                <PhotoIcon />
            ) : (
                <SubmissionPhoto
                    src={data.thumbnail}
                    alt={data.originalFilename}
                />
            )}
            <HoverTextOverlay hoverText={data.originalFilename} />
        </>
    );
};

SubmissionsGridItemContent.propTypes = {
    data: PropTypes.shape({
        thumbnail: PropTypes.string,
        originalFilename: PropTypes.string
    })
};

export default SubmissionsGridItemContent;
